{
  "actionbar.actions": "פעולות",
  "actionbar.actionsAvailable": "פעולות זמינות.",
  "actionbar.clearSelection": "נקה בחירה",
  "actionbar.selected": "{count, plural, =0 {לא בוצעה בחירה} one { # בחר} other {# נבחרו}}\",",
  "actionbar.selectedAll": "כל הפריטים שנבחרו",
  "breadcrumbs.more": "פריטים נוספים",
  "button.pending": "ממתין ל",
  "calendar.invalidSelection": "נבחר {selectedCount, plural, one {תאריך} other {תאריכים}} אינו זמין.",
  "combobox.noResults": "אין תוצאות",
  "contextualhelp.help": "עזרה",
  "contextualhelp.info": "מידע",
  "datepicker.endTime": "שעת סיום",
  "datepicker.startTime": "שעת התחלה",
  "datepicker.time": "זמן",
  "dialog.alert": "התראה",
  "dialog.dismiss": "התעלם",
  "dropzone.replaceMessage": "שחרר את הקובץ להחלפה",
  "inlinealert.informative": "מידע",
  "inlinealert.negative": "שגיאה",
  "inlinealert.notice": "אזהרה",
  "inlinealert.positive": "הצלחה",
  "label.(optional)": "(אופציונלי)",
  "label.(required)": "(נדרש)",
  "menu.moreActions": "פעולות נוספות",
  "notificationbadge.indicatorOnly": "פעילות חדשה",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "בחר…",
  "slider.maximum": "מקסימום",
  "slider.minimum": "מינימום",
  "table.loading": "טוען...",
  "table.loadingMore": "טוען עוד...",
  "table.resizeColumn": "שנה את גודל העמודה",
  "table.sortAscending": "מיין בסדר עולה",
  "table.sortDescending": "מיין בסדר יורד",
  "tag.actions": "פעולות",
  "tag.hideButtonLabel": "הצג פחות",
  "tag.noTags": "ללא",
  "tag.showAllButtonLabel": "הצג הכל ({tagCount, number})",
  "toast.clearAll": "נקה הכול",
  "toast.collapse": "כווץ",
  "toast.showAll": "הצג הכול"
}
